import {h, Fragment} from "preact"
export default function SubmitButton({ className, text, query }) {
    return (
        <div className={`ns-autocomplete-submit ns-d-flex ${className}`}>
            <button type="submit" id="ns-autocomplete-submit-button" className="predictive-search__item">
            Search for “{query}”
            </button>
        </div>
    )
}